import React, { useEffect, useState } from 'react';
import { localizationText } from '../../../common/docs/content';
import ParentDocCard from '../../common/ParentDocCard';
import { ActiveLanguagesTab } from './ActiveLanguagesTab';
import { LocalizationTab } from './LocalizationTab';

export const Localization = ({
  projectId,
  localization,
  saveLocalizationConfig,
  deleteLocalizationConfig,
  changeDefaultLanguage,
  addLocalizationKeyValue,
  deleteLocalizationKeyValue,
  updateLocalizationKeyValue,
  deleteFlag,
  actions,
}) => {
  // useEffect(() => {
  //   actions.loadLocalizationData({ projectId });
  // }, []);
  if (!localization) return '';
  const maximumActiveLanguages = process.env.REACT_APP_MAXIMUM_ACTIVE_LANGUAGES || 3;
  const [toggleActiveLang, setToggleActiveLang] = useState(false);
  return (
    <>
      <LocalizationTab
        projectId={projectId}
        localization={localization}
        maximumActiveLanguages={maximumActiveLanguages}
        addLocalizationKeyValue={addLocalizationKeyValue}
        deleteLocalizationKeyValue={deleteLocalizationKeyValue}
        updateLocalizationKeyValue={updateLocalizationKeyValue}
        setToggleActiveLang={setToggleActiveLang}
        deleteFlag={deleteFlag}
      />
      <ActiveLanguagesTab
        projectId={projectId}
        localization={localization}
        saveLocalizationConfig={saveLocalizationConfig}
        deleteLocalizationConfig={deleteLocalizationConfig}
        changeDefaultLanguage={changeDefaultLanguage}
        maximumActiveLanguages={maximumActiveLanguages}
        toggleActiveLang={toggleActiveLang}
        setToggleActiveLang={setToggleActiveLang}
      />
      <ParentDocCard>
        <h5>
          <b>About Localization</b>
        </h5>
        <p>{localizationText}</p>
        <br />
        {/* <DocsLink link="https://academy.drapcode.com/docs/app-settings/robots.txt/" /> */}
      </ParentDocCard>
    </>
  );
};
